import { render, staticRenderFns } from "./singleYuZhong.vue?vue&type=template&id=874b513e&scoped=true"
import script from "./singleYuZhong.vue?vue&type=script&lang=js"
export * from "./singleYuZhong.vue?vue&type=script&lang=js"
import style0 from "./singleYuZhong.vue?vue&type=style&index=0&id=874b513e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "874b513e",
  null
  
)

export default component.exports